<script setup lang="ts">
import { computed } from 'vue';

import { getStrCell } from '@/utils/file';

export interface Props {
  item?: string | number | null;
  ext?: (item: unknown) => unknown;
}
const props = withDefaults(defineProps<Props>(), {
  item: undefined,
  ext: (item: unknown) => item,
});

const cell = computed(() => {
  return getStrCell(props.ext(props.item));
});
</script>

<template>
  {{ cell }}
</template>
